const regExpValidator = (regExp, message = '') => ({
  pattern: {
    value: regExp,
    message
  }
});

export default regExpValidator;
